/**
 * @desc 保存Fnsku
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: Array<defs.omsFlow.FnskuToMapRpcDto>, options?: any) {
  return updateResponse(
    http(URL + `/rpc/msku/saveAmazonFnSku`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
